export enum rbacActions {

    GetDashboard = 'GetDashboard',
    ViewGettingStarted = 'ViewGettingStarted',

    ListDomainNames = 'ListDomainNames',
    GetDomainName = 'GetDomainName',
    CreateDomainName = 'CreateDomainName',
    UpdateDomainName = 'UpdateDomainName',
    DeleteDomainName = 'DeleteDomainName',
    BulkImportDomainNames = 'BulkImportDomainNames',

    ListRegistrars = 'ListRegistrars',
    GetRegistrar = 'GetRegistrar',
    CreateRegistrar = 'CreateRegistrar',
    UpdateRegistrar = 'UpdateRegistrar',
    DeleteRegistrar = 'DeleteRegistrar',

    // FNP-973 — read-only module: list and get only. No Create/Update/Delete
    // action, because the deployed schema has no hosted-zone mutation to gate
    // (writes are FNP-977).
    ListHostedZones = 'ListHostedZones',
    GetHostedZone = 'GetHostedZone',

    // FNP-1186 — registered ahead of the three modules that use them
    // (FNP-1191 Zones, FNP-1192 Records, FNP-1193 Certificates) so those
    // tickets never edit this shared file and collide with each other.
    //
    // ⚠️ An action here that is NOT in the deployed AVP policy store can never
    // resolve to ALLOW on its own merits; the admin catch-all policy hides
    // that, so it fails closed and silently for everyone else (FNP-1095).
    // These are handed to the owner for the admin-console schema edit.
    ListZones = 'ListZones',
    GetZone = 'GetZone',
    CreateZone = 'CreateZone',
    UpdateZone = 'UpdateZone',
    DeleteZone = 'DeleteZone',

    // FNP-1248 — the provider-connections module.
    //
    // ⚠️ Five actions for four operations, because `ConnectProvider` and
    // `UpdateProviderConnection` are different rights: connecting adds a new
    // integration, re-validating replaces the credential on one that already
    // exists. A tenant role that may fix a broken connection is not necessarily
    // one that may add another provider.
    //
    // ⚠️ An action here that is NOT in the deployed AVP policy store can never
    // resolve to ALLOW on its own merits; the admin catch-all policy hides
    // that, so it fails closed and silently for everyone else (FNP-1095).
    // These need the admin-console schema edit before non-admin tenants can
    // reach the module.
    ListProviderConnections = 'ListProviderConnections',
    GetProviderConnection = 'GetProviderConnection',
    ConnectProvider = 'ConnectProvider',
    UpdateProviderConnection = 'UpdateProviderConnection',
    DisconnectProvider = 'DisconnectProvider',

    ListDnsRecords = 'ListDnsRecords',
    GetDnsRecord = 'GetDnsRecord',
    CreateDnsRecord = 'CreateDnsRecord',
    UpdateDnsRecord = 'UpdateDnsRecord',
    DeleteDnsRecord = 'DeleteDnsRecord',

    // Certificates have no Update: a certificate is immutable once issued, so
    // the write surface is request and delete (FNP-1193 acceptance criteria).
    ListCertificates = 'ListCertificates',
    GetCertificate = 'GetCertificate',
    RequestCertificate = 'RequestCertificate',
    DeleteCertificate = 'DeleteCertificate',

    ListTopLevelDomains = 'ListTopLevelDomains',
    GetTopLevelDomain = 'GetTopLevelDomain',
    CreateTopLevelDomain = 'CreateTopLevelDomain',
    UpdateTopLevelDomain = 'UpdateTopLevelDomain',
    DeleteTopLevelDomain = 'DeleteTopLevelDomain',

    ListApplicationProducts = 'ListApplicationProducts',
    GetApplicationProduct = 'GetApplicationProduct',
    CreateApplicationProduct = 'CreateApplicationProduct',
    UpdateApplicationProduct = 'UpdateApplicationProduct',
    DeleteApplicationProduct = 'DeleteApplicationProduct',

    ListSettings = 'ListSettings',
    GetSetting = 'GetSetting',
    UpdateSetting = 'UpdateSetting',
}

export const actions = Object.values(rbacActions);

